import React                  from 'react';
import { Observe }                 from 'rewire-core';
import { StyleType }               from '../utility/styles';
import { useCardStyle }            from './UdfEditor';
import InfoPanelHeader             from '../ui/InfoPanelHeader';
import SettingsModel               from './SettingsModel';
import employeeEditorViewTabs      from './EmployeeEditorViewTabs';

const EmployeeEditPanelHeaderView = ({ settings }: { settings: SettingsModel, classes: StyleType<typeof useCardStyle> }) => {
  return <Observe render={() => {
    const headerOptionsTitle = `${settings.title} Options`;
    return (
      <InfoPanelHeader
        title={settings.title}
        subTitle={`${(settings.selectedItem && settings.editor?.title) || ''}`}
        tabs={settings.selectedItem && employeeEditorViewTabs}
        optionsMenuTitle={headerOptionsTitle}
        optionsMenuTooltip={headerOptionsTitle}
        optionsItems={settings.getDefaultEditPanelHeaderOptionsItems()}
      />
    );
  }} />;
};

export default EmployeeEditPanelHeaderView;